export const VehicleMakeMasterEndpoints = (builder) => ({

    getVehicleMakeMasters: builder.query({
        query: (args = {}) => {
            const {
                pageNumber = 1,
                pageSize = 10,
                searchTerm,
                searchValue,
                sortField,
                sortOrder,
            } = args;

            const params = {
                pageNumber,
                pageSize,
            };

            if (searchTerm) params.searchTerm = searchTerm;
            if (searchValue) params.searchValue = searchValue;
            if (sortField) params.sortField = sortField;
            if (sortOrder) params.sortOrder = sortOrder;

            return {
                url: '/VehicleMake/VehicleMakeMaster',
                method: 'POST',
                body: params,
            };
        },
        providesTags: ['VehicleMakeMaster'],
    }),

    getVehicleMakeById: builder.query({
        query: (id) => `/VehicleMake/get-vehicle-make/${id}`,
        providesTags: (result, error, id) => [{ type: 'VehicleMakeMaster', id }],
    }),

    saveVehicleMake: builder.mutation({
        query: (data) => ({
            url: '/VehicleMake/SaveVehicleMakeMaster',
            method: 'POST',
            body: data,
        }),
        invalidatesTags: ['VehicleMakeMaster'],
    }),

    updateVehicleMake: builder.mutation({
        query: ({ id, data }) => ({
            url: `/VehicleMake/SaveVehicleMakeMaster`,
            method: 'POST',
            body: data,
        }),
        invalidatesTags: (result, error, { id }) => [
            { type: 'VehicleMakeMaster', id },
            'VehicleMakeMaster'
        ],
    }),

    deleteVehicleMake: builder.mutation({
        query: (id) => ({
            url: `/VehicleMake/delete-vehicle-make/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: ['VehicleMakeMaster'],
    }),

    bulkDeleteVehicleMake: builder.mutation({
        query: (ids) => ({
            url: "/VehicleMake/bulk-delete-vehicle-make",
            method: "POST",
            body: { ids },
        }),
        invalidatesTags: ['VehicleMakeMaster'],
    }),

    getVehicleMakesForDropdown: builder.query({
        query: (vehicleType) => `/VehicleMake/get-vehicle-makes-for-dropdown${vehicleType ? `?type=${vehicleType}` : ""}`,
        providesTags: ['VehicleMakeMaster'],
    }),

});
